import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LoginForm({ onSuccess, submitLabel = 'Sign in' }) {
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const [requires2fa, setRequires2fa] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      await login(email, password, requires2fa ? otpCode : undefined);
      onSuccess?.();
    } catch (err) {
      const data = err?.response?.data || {};
      const needs2fa = Boolean(data.requires_2fa || data.otp_code);

      if (needs2fa && !requires2fa) {
        setRequires2fa(true);
        setError('Enter the 6-digit code from Google Authenticator.');
      } else if (needs2fa) {
        setError('Authenticator code is invalid.');
      } else {
        setError(err?.message || 'Login failed. Please check your email/password.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="login-page__form">
      <label className="login-page__label">
        Email
        <input
          className="login-page__input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
      </label>

      <label className="login-page__label">
        Password
        <input
          className="login-page__input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
      </label>

      {requires2fa ? (
        <label className="login-page__label">
          Authenticator code
          <input
            className="login-page__input"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength="6"
            value={otpCode}
            onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            autoComplete="one-time-code"
            required
          />
        </label>
      ) : null}

      {error ? <div className="login-page__error">{error}</div> : null}

      <button type="submit" disabled={submitting} className="login-page__submit">
        {submitting ? 'Signing in…' : submitLabel}
      </button>
    </form>
  );
}
